import { Navigate } from 'react-router-dom'
import { PageHeader } from '@/components/common/PageHeader'
import { useAuthStore } from '@/features/auth/store'
import { HaloUserSyncCard } from './HaloUserSyncCard'

export function AdminPage() {
  const user = useAuthStore((s) => s.user)

  // Strona admin - wymaga superusera. Permissions per-action (np. partners.admin.*) damy w F1.5.2+.
  if (!user) return null
  if (!user.superuser) {
    return <Navigate to="/" replace />
  }

  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        title="Administracja"
        subtitle="Operacje konfiguracyjne i synchronizacje"
      />
      <HaloUserSyncCard />
    </div>
  )
}
